export enum LocalStorageKey {
  Locale = 'locale-v2',
  Viewer = 'viewer',
  MenuGroupOpen = 'menu-group-open',
  PreviewHeaderCollapsed = 'preview-manually-collapsed',
  UpdateOnlyActiveSection = 'update-only-active-section',
}
